import { html } from "lit";
var icon_tacticalWorkflow_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M6.75 13.5a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm6.295-5.106c.301.402.659.76 1.061 1.06l-3.151 3.152a5.286 5.286 0 00-1.062-1.061l3.152-3.15zM17.25 3a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm0 1.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_tacticalWorkflow_default as default
};
//# sourceMappingURL=icon-tacticalWorkflow.js.map
